/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const integrationInstanceSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  credentialsId: z.int(),
  credentialsUpdatedAt: z.iso.datetime(),
  credentialsUpdatedBy: z.string(),
  id: z.int(),
  instanceId: z.string(),
  instanceName: z.string(),
  instanceUrl: z.string(),
  organizationId: z.string(),
  sourceSystemType: z.enum(['JIRA', 'ADO']),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
